import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { useState } from "react";

interface AlertModalProps {
  text?: string;
}

const AlertModal: React.FC<AlertModalProps> = ({ text }) => {
  const [open, setOpen] = useState(true);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="relative z-30"
    >
      <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel className="relative transform overflow-hidden rounded-lg bg-gray-900 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-sm sm:translate-y-0 sm:scale-95">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
            >
              <XMarkIcon className="w-5 h-5" />
              <span className="sr-only">Close modal</span>
            </button>

            <div className="p-4 border-b rounded-t border-gray-600">
              <h3 className="text-base font-semibold text-white">{text}</h3>
            </div>

            {/* <div className="p-4">
              <p className="font-medium text-white">{text}</p>
            </div> */}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AlertModal;
